import { createUseDocumentTitleHook } from '@cmg/common';

/**
 * Singleton of useDocumentTitle for identity-client-web, created from hook factory function
 */
export const useDocumentTitle = createUseDocumentTitleHook('CMG Identity and User Management');
